<div class="ontario-padding-bottom-48-!">
    <div class="ontario-row">
        <div class="ontario-columns top-banner">
            <!-- Error -->
            <div id="errorDiv" #errorDiv>
                @if(validationFailed){
                    <div class="ontario-alert ontario-alert--error" id="errorHeading" #errorHeading tabindex="0">
                        <div class="ontario-alert__header">
                            <div class="ontario-alert__header-icon">
                                <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                    <use href="#ontario-icon-alert-error"></use>
                                </svg>
                            </div>
                            <h2 class="ontario-alert__header-title ontario-h4">{{'Error.ThereIsAProblem' | translate}}</h2>
                        </div>
                        <div class="ontario-alert__body" role="alert">
                            <p>{{'Error.ErrorsWereFoundOnThisPage' | translate}}</p>
                            <ul> 
                                @if(invalidCharacterError){
                                    <li><a href="javascript:{}" (click)="scrollToElement('planNameLabel')">{{'HardcodedGlobals.OneOfInvalidError' | translate}}</a></li>
                                }   
                                @if(planNameTooLong){
                                    <li><a href="javascript:{}" (click)="scrollToElement('planNameLabel')">{{'NewPlanStep1.NameOfSafetyPlanTooLong' | translate}}</a></li>
                                }
                                @if(planNameInvalid){
                                    <li><a href="javascript:{}" (click)="scrollToElement('planNameLabel')">{{'NewPlanStep1.NameOfSafetyPlanInvalidError' | translate}}</a></li>
                                }
                                @if(contactNameEmpty){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNameLabel')">{{'NewPlanStep1.ContactNameCannotEmpty' | translate}}</a></li>
                                }
                                @if(contactNameInvalid){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNameLabel')">{{'NewPlanStep1.ContactNameInvalidError' | translate}}</a></li>
                                }
                                @if(contactNameTooLong){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNameLabel')">{{'NewPlanStep1.ContactNameTooLong' | translate }}</a></li>
                                }
                                @if(contactNumberEmpty){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNumberLabel')">{{'NewPlanStep1.ContactNumberCannotEmpty' | translate}}</a></li>
                                }
                                @if(contactNumberTooLong){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNumberLabel')">{{'NewPlanStep1.ContactNumberTooLong' | translate }}</a></li>
                                }
                                @if(contactNumberInvalid){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactNumberLabel')">{{'NewPlanStep1.ContactNumberInvalidError' | translate}}</a></li>
                                }
                                @if(contactEmailEmpty){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactEmailLabel')">{{'NewPlanStep1.ContactEmailCannotEmpty' | translate}}</a></li>
                                }
                                @if(contactEmailTooLong){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactEmailLabel')">{{'NewPlanStep1.ContactEmailTooLong' | translate }}</a></li>
                                }
                                @if(contactEmailXssFailed){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactEmailLabel')">{{'NewPlanStep1.ContactEmailInvalidError' | translate}}</a></li>
                                }
                                @if(contactEmailInvalid){
                                    <li><a href="javascript:{}" (click)="scrollToElement('contactEmailLabel')">{{'NewPlanStep1.InvalidEmail' | translate}}</a></li>
                                }
                                @if(noteTooLong){
                                    <li><a href="javascript:{}" (click)="scrollToElement('notesLabel')">{{'NewPlanStep1.NotesTooLong' | translate }}</a></li>
                                }  
                                @if(noteInvalid){
                                    <li><a href="javascript:{}" (click)="scrollToElement('notesLabel')">{{'NewPlanStep1.NotesInvalidError' | translate}}</a></li>
                                }
                            </ul>
                        </div>
                    </div>
                }
            </div>
            <div class="ontario-step-indicator">
                <div class="ontario-row">
                    <div class="ontario-columns ontario-small-12">
                        <div class="ontario-step-indicator--without-back-button">
                            <span class="ontario-h4">{{'Stepper.Title1' | translate}}</span>
                        </div>
                        <hr />
                    </div>
                </div>
            </div>
            <h1 class="title">
                {{'NewPlanStep1.BasicInformation' | translate}}
            </h1>
        </div>
    </div>
    <div class="row">
        <div class="ontario-columns">
        <fieldset class="ontario-fieldset">
            <legend class="sr-only">Plan Name</legend>
                <label class="ontario-label" for="planname" id="planNameLabel">
                    {{'NewPlanStep1.SafetyPlanName' | translate}}<span class="ontario-label__flag">({{'HardcodedGlobals.Optional' | translate}})</span>
                </label>
                @if(planNameTooLong){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.NameOfSafetyPlanTooLong' | translate}}
                        </span>
                    </div>
                }
                @if(planNameInvalid){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.NameOfSafetyPlanInvalidError' | translate}}
                        </span>
                    </div>
                }
                <input class="ontario-input" type="text" id="planname" autocomplete="organization" [(ngModel)]="planNameValue" [class.ontario-input__error]="planNameTooLong || invalidCharacterError || planNameInvalid">
        </fieldset>
        </div>
    </div>
    <div class="row">
        <div class="ontario-columns">
        <fieldset class="ontario-fieldset">
            <legend class="sr-only">Contact Name</legend>
                <label class="ontario-label" for="contactname" id="contactNameLabel">
                    {{'NewPlanStep1.ContactName' | translate}} <span class="ontario-label__flag">({{'HardcodedGlobals.Required' | translate}})</span>
                </label>
                @if(contactNameEmpty){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNameCannotEmpty' | translate}}
                        </span>
                    </div>
                }
                @if(contactNameInvalid){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNameInvalidError' | translate}}
                        </span>
                    </div>
                }
                @if(contactNameTooLong){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNameTooLong' | translate }}
                        </span>
                    </div>
                }
                <input class="ontario-input" type="text" id="contactname" autocomplete="name" [(ngModel)]="contactNameValue" [class.ontario-input__error]="contactNameInvalid || contactNameTooLong || contactNameEmpty || invalidCharacterError">
        </fieldset>
        </div>
    </div>
    <div class="row">
        <div class="ontario-columns">
        <fieldset class="ontario-fieldset">
            <legend class="sr-only">Contact Number</legend>
                <label class="ontario-label" for="contactnumber" id="contactNumberLabel">
                    {{'NewPlanStep1.ContactNumber' | translate}} <span class="ontario-label__flag">({{'HardcodedGlobals.Required' | translate}})</span>
                </label>
                @if(contactNumberEmpty){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNumberCannotEmpty' | translate}}
                        </span>
                    </div>
                }
                @if(contactNumberInvalid){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNumberInvalidError' | translate}}
                        </span>
                    </div>
                }
                @if(contactNumberTooLong){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactNumberTooLong' | translate }}
                        </span>
                    </div>
                }
                <input class="ontario-input" type="text" id="contactnumber" autocomplete="tel" [(ngModel)]="contactNumberValue" [class.ontario-input__error]="contactNumberInvalid || contactNumberTooLong || contactNumberEmpty || invalidCharacterError">
        </fieldset>
        </div>
    </div>
    <div class="row">
        <div class="ontario-columns">
        <fieldset class="ontario-fieldset">
            <legend class="sr-only">Contact Email</legend>
                <label class="ontario-label" for="contactemail" id="contactEmailLabel">
                    {{'NewPlanStep1.ContactEmail' | translate}} <span class="ontario-label__flag">({{'HardcodedGlobals.Required' | translate}})</span>
                </label>
                @if(contactEmailEmpty){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactEmailCannotEmpty' | translate }}
                        </span>
                    </div>
                }
                @if(contactEmailTooLong){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactEmailTooLong' | translate }}
                        </span>
                    </div>
                }
                @if(contactEmailXssFailed){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.ContactEmailInvalidError' | translate }}
                        </span>
                    </div>
                }
                @if(contactEmailInvalid){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.InvalidEmail' | translate}}
                        </span>
                    </div>
                }
                <input class="ontario-input" type="text" id="contactemail" autocomplete="email" [(ngModel)]="contactEmailValue" [class.ontario-input__error]="contactEmailEmpty || contactEmailTooLong || contactEmailXssFailed || contactEmailInvalid || invalidCharacterError">
        </fieldset>
        </div>
    </div>
    <div class="row">
        <div class="ontario-columns">
        <fieldset class="ontario-fieldset">
            <legend class="sr-only">Notes</legend>
                <label class="ontario-label" for=" notes" id="notesLabel">
                    {{'NewPlanStep1.Notes' | translate}} <span class="ontario-label__flag">({{'HardcodedGlobals.Optional' | translate}})</span>
                </label>
                @if(noteTooLong){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.NotesTooLong' | translate }}
                        </span>
                    </div>
                }
                @if(noteInvalid){
                    <div class="ontario-error-messaging" id="field-error">
                        <span class="ontario-error-messaging__icon">
                            <svg class="ontario-icon" alt="" aria-hidden="true" focusable="false" sol:category="primary" viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                                <use href="#ontario-icon-alert-error"></use>
                            </svg>
                        </span>
                        <span class="ontario-error-messaging__content">
                            {{'NewPlanStep1.NotesInvalidError' | translate}}
                        </span>
                    </div>
                }
                <textarea class="ontario-input ontario-textarea" type="text" id=" notes" [(ngModel)]="notesValue" [class.ontario-input__error]="noteInvalid || noteTooLong || invalidCharacterError"></textarea>
        </fieldset>
        <br>
        <button (click)="saveAndContinue()" class="ontario-button ontario-button--primary">
            {{ 'Buttons.SaveAndContinue' | translate }}
        </button>        
        </div>
    </div>
  </div>

